import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button, Form, Image } from 'react-bootstrap'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import CounterInput from 'react-bootstrap-counter';
import { apiUrl } from "../commons/inFormTypes"
import { IPUrl } from "../commons/IPAddress"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Loaders from '../components/Loaders'
import NumericInput from 'react-numeric-input';

function OrderFormReg({ toggle, toggleHandler1 }) {
  const [minSum, setMinSum] = useState();
  const [lstarrayInfo, setLstarrayInfo] = useState([]);
  const [snip1, setSnip1] = useState(false);
  const [codeMeli, setCodeMeli] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [seenFile, setSeenFile] = useState([]);
  const [formIsValid, setFormIsValid] = useState("1");
  const [lstarray, setLstarray] = useState([]);
  const [master, setMaster] = useState([{
    weight: 0, coint: 0, address: "", time: "",
    Type_Area_Id: 0, Type_Area: "", day: "", date: "", stationTitle: "",
    stationAddress: "", stationId: 0,
  }]);
  const [Stchange, setstchange] = useState(false);
  const [key, setKey] = useState(false)
  const navigate = useNavigate()
  const userToken = localStorage.getItem("user_token");


  const AddListState = (val, name, id, count, score, idWeight, titleWeight, icon, minweight) => {
    const indx = lstarray.findIndex((i) => i.id === id);

    if (indx < 0 && val === true) {
      lstarray.push({

        name: name,
        id: id,
        count: count,
        score: score,
        Sum: count * score,
        idWeight: idWeight,
        titleWeight: titleWeight,
        icon: icon,
        minweight: minweight,
      })
      setLstarray(lstarray)
    }
    else if (val === false) {
      var l = lstarray.filter((i) => i.id !== id)
     setLstarray(l)
    }

  }

  const AddCounter = (id, val) => {
    if (Stchange)
      setstchange(false)
    else
      setstchange(true)
    const indx = lstarray.findIndex((i) => i.id === id);
    lstarray[indx].count = parseFloat(val);
    lstarray[indx].Sum = parseFloat(lstarray[indx].score * lstarray[indx].count);
  }


  const submitHandler = () => {
    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را انتخاب کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setFormIsValid("2")
    }
  }

  const newItemsHandler = () => {
    setFormIsValid("1")
    //   setKey(prevState => !prevState)
  }

  const removeHandler = (id) => { 
     const l = lstarray.filter((i) => i.id !== id)
     setLstarray(l)
    if (Stchange)
      setstchange(false)
    else
      setstchange(true)
  }

  const subHandler = () => {

    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را اضافه کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      for (let i = 0; i < lstarray.length; i++) {
        master[0].weight += lstarray[i].count
        master[0].coint += lstarray[i].Sum
      }
      if (master[0].coint < minSum) {
        toast.error("مجموع مبلغ پسماندها باید از حداقل مبلغ تعیین شده بیشتر باشد", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false

      } else {
      }


      // for (let i = 0; i < lstarray.length; i++) {
      //   if (lstarray[i].count < lstarray[i].minweight) {
      //     toast.error("وزن پسماند مورد نظر کمتر از حداقل وزن تعیین شده کمتر میباشد", {
      //       position: "top-center",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //     });
      //     return false
      //   } else {
      //     master[0].weight += lstarray[i].count
      //     master[0].coint += lstarray[i].Sum
      //   }
      // }

      localStorage.setItem("Master", JSON.stringify(master));
      localStorage.setItem("Lstarray", JSON.stringify(lstarray));

      navigate("finalinfo");
    }
  }


  useEffect(() => {
    if (userToken === null) {
      navigate("/");
    } else {
      const CodeMeliUser = localStorage.getItem("CodeMeli");
      if (CodeMeliUser === "" || CodeMeliUser === null) {
        setLstarray([])
        setCodeMeli("")
        setName("")
        setMobile("")
        setMaster([{
          weight: 0, coint: 0, address: "", time: "",
          Type_Area_Id: 0, Type_Area: "", day: "", date: "", stationTitle: "",
          stationAddress: "", stationId: 0,
        }])
      }

      if (lstarrayInfo.length === 0) {
        const axios = require("axios");
        axios
          .post(apiUrl + "GetList_Trash")
          .then((res) => {
            if (res.data.result === "true") {
              setSeenFile(res.data.data);
              setMinSum(res.data.MinSum);
              // for (let i = 0; i < res.data.data.length; i++) {
              //   lstarrayInfo.push({
              //     Tittle: res.data.data[i].Tittle,
              //     Trashd: res.data.data[i].Trashd,
              //     Event_Coint: res.data.data[i].Event_Coint,
              //     Type_Weight: res.data.data[i].Type_Weight,
              //     Type_Weight_Tittle: res.data.data[i].Type_Weight_Tittle,
              //     Icon: res.data.data[i].Icon
              //   })
              // }
              // setLstarrayInfo(lstarrayInfo)
            } else {
            }
          });
      }
    }
  }, [Stchange, toggle]);

  const searchHandler = (e) => {
    localStorage.removeItem("CodeMeli");
    localStorage.removeItem("users_name");

    if (codeMeli === "")
      return false;

    const axios = require("axios");
    axios
      .post(apiUrl + "Get_Userinfo", {
        TokenId: userToken,
        Code_Meli: codeMeli,
      })
      .then((res) => {
        if (res.data.result === "true" && res.data.data_Users.Name !== null) {
          localStorage.setItem("CodeMeli", res.data.data_Users.Code_Melii);
          localStorage.setItem("users_name", res.data.data_Users.Name);
          setName(res.data.data_Users.Name);
          setMobile(res.data.data_Users.Mobile);
          let sk = "100/1000/10";
        } else {
          setName("")
          setMobile("")
          toast.error("کدملی موجود نمی باشد", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });

  }

  const submitInfoHandler = () => {

    if ((codeMeli == "" || codeMeli.length > 10 || codeMeli.length < 10)
      || (mobile.length < 11 || mobile.length > 11 || mobile === "" || !mobile.startsWith("09"))
      || name == "") {
      toast.error("لطفا اطلاعات صحیح را وارد نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })

      return false;
    }

    const CodeMeliUser = localStorage.getItem("CodeMeli");
    if (CodeMeliUser === "" || CodeMeliUser === null || CodeMeliUser !== codeMeli) {


      const axios = require("axios");
      setSnip1(true);
      axios
        .post(apiUrl + "Register_Station", {
          TokenId: userToken,
          FirstName: name,
          Codemelli: codeMeli,
          mobile: mobile
        })
        .then((res) => {
          setSnip1(false);
          if (res.data.result === "true") {
            localStorage.setItem("CodeMeli", res.data.data.Code_Melii);
            localStorage.setItem("users_name", res.data.data.Name);

            submitHandler();
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });

    }
    else {
      submitHandler();
    }
  }

  //enter for input insted of click button
  const keyPress = (e) => {
    if (e.keyCode === 13) {
      searchHandler(e)
    }
  }

  //Focus on the Next Field
  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };



  return (
    <>
      <BottomSheet
        open={toggle}
        onDismiss={toggleHandler1}
        initialFocusRef={false}
        expandOnContentDrag
      >
        <div>
          <Container>
            <div className="rgc-close-icon">
              <i class="fa-regular fa-circle-xmark" onClick={toggleHandler1}></i>
            </div>
            <Row className="justify-content-center">

              <Col xs={12} lg={8} className="p-4 mb-4">

                {/* first-part */}
                <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                  <Row className="rgc-orderform gx-5 gy-3">
                    <Form>
                      <Col xs={12} className="rgc-info">
                        <Row>
                          <Col xs={7} md={4} className="ms-auto">
                            <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicCode">
                              <Form.Label>جستجو کد ملی </Form.Label>
                              <i class="fas fa-search"
                                aria-hidden="true"
                                style={{ cursor: "pointer" }}
                                onClick={searchHandler}
                              ></i>
                              <Form.Control
                                autoComplete="off"
                                type="number"
                                placeholder="کد ملی"
                                className="rgc-profile-input"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={codeMeli}
                                onChange={(e) => setCodeMeli(e.target.value)}
                                onKeyDown={(event) => keyPress(event)}
                              />
                            </Form.Group>

                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} md={4}>
                            <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicName">
                              <Form.Label>نام و نام خانوادگی</Form.Label>
                              <i className='fas fa-user-alt'></i>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                placeholder="نام و نام خانوادگی"
                                className="rgc-profile-input"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                onKeyDown={handleEnter}
                              />
                            </Form.Group>
                          </Col>

                          <Col xs={12} md={4}>
                            <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicNumber">
                              <Form.Label>شماره همراه</Form.Label>
                              <i class="fas fa-mobile-alt" aria-hidden="true"></i>
                              <Form.Control
                                autoComplete="off"
                                type="number"
                                placeholder="شماره همراه"
                                className="rgc-profile-input"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                onKeyDown={handleEnter}
                              />
                            </Form.Group>
                          </Col>

                          <Col xs={12} md={4}>
                            <Form.Group className="mb-3 rgc-input-icons" controlId="formBasicName">
                              <Form.Label> کدملی  </Form.Label>
                              <i className='fas fa-user-alt'></i>
                              <Form.Control
                                autoComplete="off"
                                type="number"
                                placeholder="کدملی"
                                className="rgc-profile-input"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={codeMeli}
                                onChange={(e) => setCodeMeli(e.target.value)}
                                onKeyDown={handleEnter}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                      </Col>
                    </Form>
                    <Col xs={12}>
                      <div className="d-flex rgc-title">
                        <div className="rgc-title-point"></div>
                        <h4>ثبت <span>سفارش</span></h4>
                      </div>
                    </Col>
                    {seenFile.map((data, index) => {
                      return (
                        <Col key={index} xs={12} md={6}>
                          <Row className="justify-content-center  rgc-station-time">
                            <Col xs={2}>
                              <Form.Group controlId="formBasicCheckbox">
                                {lstarray.findIndex((i) => i.id === data.Trashd) >= 0 ?
                                  <Form.Check
                                    checked={true}
                                    key={key}
                                    inline
                                    name="group1"
                                    type="checkbox"
                                    id={index}
                                    onChange={(e) =>
                                      AddListState(e.target.checked, data.Tittle, data.Trashd, 0.5,
                                        data.Event_Sum, data.Type_Weight, data.Type_Weight_Tittle,
                                        data.Icon, data.MinWeight)}
                                  /> :
                                  <Form.Check
                                    key={key}
                                    inline
                                    name="group1"
                                    type="checkbox"
                                    id={index}
                                    onChange={(e) =>
                                      AddListState(e.target.checked, data.Tittle, data.Trashd, 0.5,
                                        data.Event_Sum, data.Type_Weight, data.Type_Weight_Tittle,
                                        data.Icon, data.MinWeight)}
                                  />
                                }
                              </Form.Group>
                            </Col>

                            <Col xs={2} className="text-center">
                              <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                            </Col>

                            <Col xs={8} className="text-end">
                              <span>{data.Tittle} </span>
                            </Col>

                            <Col xs={12} className="text-start">
                              <span>مبلغ پایه:</span>
                              <span>{Intl.NumberFormat('en-US').format(data.Event_Sum)}&nbsp;ریال </span>
                            </Col>
                          </Row>

                        </Col>
                      )
                    })}

                    <Col className="rgc-order-content">
                      <Row className="justify-content-center">
                        {/* 
                        <Col xs={5} sm={3} className="text-center">
                          <Button onClick={toggle} className="rgc-order-btn rgc-order-btn-cancel">
                            بستن
                          </Button>
                        </Col> */}

                        <Col xs={5} sm={3} className="text-center">
                          <Button className="rgc-order-btn rgc-order-btn-sub" onClick={submitInfoHandler}>
                            مرحله بعد
                          </Button>
                        </Col>
                      </Row>
                    </Col>



                  </Row>
                </div>

                {/* secound-part */}
                <div className={formIsValid === "2" ? "d-block" : "d-none"}>

                  <Row className="gx-5 gy-3 rgc-order-items">

                    {lstarray.map((item) => {
                      return (
                        <Col xs={12} md={6}>
                          <Row className="justify-content-around  rgc-station-time">

                            <Col xs={2} className="rgc-order-close">
                              <i class="fa-solid fa-circle-xmark" onClick={() => removeHandler(item.id)}></i>
                            </Col>

                            <Col xs={4} className="text-start">
                              <Image src={IPUrl + item.icon} alt="" className="rgc-image" />
                            </Col>

                            <Col xs={6} className="text-end rgc-order-title">
                              <span> {item.name}</span>
                            </Col>
                            <hr className="w-75" />
                            <Col xs={12}>
                              <Form.Group className="row g-0 align-items-center justify-content-center" controlId="formBasicEmail">
                                {/* <Col xs={3} className="rgc-order-label">
                                  <Form.Label className="m-0">وزن زباله</Form.Label>
                                </Col> */}
                                <Col xs={7}>
                                  {/* <CounterInput
                                    value={item.count}
                                    min={1}
                                    onChange={(value) => { AddCounter(item.id, value) }} /> */}
                                  <NumericInput
                                    step={0.5}
                                    precision={1}
                                    min={0.5}
                                    value={parseFloat(item.count)}
                                    mobile
                                    onChange={(value) => { AddCounter(item.id, value) }}
                                  />
                                </Col>

                                <Col xs={3} className="rgc-order-label text-center">
                                  <Form.Label className="m-0">{item.titleWeight}</Form.Label>
                                </Col>
                              </Form.Group>
                            </Col>

                            <Col xs={9} className="rgc-driver-txt text-center my-2">
                              <div className="d-flex  justify-content-between">

                                <div className="rgc-order-span">
                                  <span>مبلغ پایه:</span>
                                  <span>{Intl.NumberFormat('en-US').format(item.score)}&nbsp;ریال </span>
                                </div>

                                <div className="rgc-order-span">
                                  <span>جمع مبلغ:</span>
                                  <span>{Intl.NumberFormat('en-US').format((item.Sum))}&nbsp;ریال </span>
                                </div>
                                {/* <div className="rgc-order-span">
                                  <span>حداقل وزن :</span>
                                  <span>{item.minweight}{item.titleWeight}</span>
                                </div> */}

                              </div>
                            </Col>

                          </Row>

                        </Col>
                      )
                    }
                    )}
                  </Row>

                  <Row>
                    <Col xs={12} className="rgc-order-icon">
                      <i class="fa fa-plus-circle" aria-hidden="true" onClick={newItemsHandler}></i>
                    </Col>

                    <Row>
                      <Col className="rgc-order-content">
                        <Row className="justify-content-center">
                          <Col xs={12} className="text-center rgc-order-score">
                            <span>حداقل مبلغ برای ثبت سفارش باید {Intl.NumberFormat('en-US').format(minSum)} ریال باشد</span>
                            <span>مجموع مبالغ :{Intl.NumberFormat('en-US').format(lstarray.reduce((acc, item) => acc + item.count * item.score, 0))}&nbsp;ریال </span>
                            <span>مجموع کل وزن :{(lstarray.reduce((acc, item) => acc + item.count * 1, 0)).toFixed(1)}</span>
                          </Col>

                          {/* <Col xs={5} sm={3} className="text-center">
                            <Button onClick={toggleHandler1} className="rgc-order-btn rgc-order-btn-cancel">
                              بستن
                            </Button>
                          </Col> */}

                          <Col xs={5} sm={3} className="text-center" onClick={toggleHandler1}>
                            <Button onClick={subHandler} className="rgc-order-btn rgc-order-btn-sub">
                              مرحله بعدی
                            </Button>
                          </Col>
                        </Row>

                      </Col>
                    </Row>

                  </Row>
                </div>

              </Col>
            </Row>

          </Container>

        </div>
      </BottomSheet>
    </>

  );
}

export default OrderFormReg;
